import { mdiPlus } from '@mdi/js';
import { BaconTable } from 'common/components/table/bacon';
import { TableTitle } from 'common/components/table/title';
import React from 'react';

export const RconTable = () => {
  return (
    <>
      <TableTitle icon={mdiPlus} title="Rcon" />
      <br />
      <BaconTable url={`/rcon`} defaultQ={'a:date_day/f:status:open'} />
    </>
  );
};
